<p>
  This sample demonstrates three edit modes:
  <code>dialog</code>, <code>inline-auto</code>, and <code>inline-button</code>.
  Switch modes and edit <strong>First Name</strong>, <strong>Last Name</strong>, or <strong>Biography</strong> to compare behavior.
  When <strong>inline-button</strong> is selected, use <strong>Inline Save/Cancel</strong> to choose text, icon, or text+icon buttons.
  Use <strong>Add Button</strong> to choose no built-in create button, a button below the grid, or a button in the panel header.
  Enable <strong>Allow Delete</strong> to show delete actions (next to Edit in inline-button mode, by itself in inline-auto mode).
</p>

<ui-form
  [config]="modeFormConfig"
  [(formValues)]="modeFormValues"
></ui-form>

<ui-grid
  [dsConfig]="dsConfig()"
  [agGridOptions]="agGridOptions"
  [panelHeaderConfig]="panelHeaderConfig()"
  [showPanelHeader]="true"
  [pageSizes]="[5, 10, 20]"
></ui-grid>
